import { ShowDetails } from '../pages/ShowDetails'
import { ErrorState } from './ErrorState'

interface ShowDetailsRouteProps {
  id?: string
}

export function ShowDetailsRoute({ id }: ShowDetailsRouteProps) {
  // Route validation - ensure ID exists and is numeric
  if (!id) {
    return <ErrorState message="Show ID is required" />
  }

  const numericId = parseInt(id)
  if (isNaN(numericId) || numericId <= 0) {
    return <ErrorState message="Invalid show ID" />
  }

  // ID is valid, render the actual component
  return <ShowDetails id={id} />
}
